import { render, staticRenderFns } from "./DashboardJournal.vue?vue&type=template&id=fa6719f4&"
import script from "./DashboardJournal.vue?vue&type=script&lang=js&"
export * from "./DashboardJournal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports